export const TabsDT = {
	tabs: {
		css: ({ dt }) => `
              .p-tabs-marketing.p-tab-active {
                  border-color: var(--p-marketing-carrot);
                  color: var(--p-marketing-carrot);
              }
              .p-tabs-marketing.p-tab {
                  border-width: 0 0 2px 0;
              }
        `,
	},
};
